import { faEnvelope, faGear, faEnvelopeCircleCheck, faMegaphone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './EmailMarketingTabs.module.scss';

export const emailCampaignsTabId = 'email-campaigns';
export const emailTemplatesTabId = 'email-templates';
export const emailSenderTabId = 'email-sender';

interface EmailMarketingTabsProps {
    selectedTabId: string;
    onSelect: (tabId: string) => void;
    className?: string;
}

const EmailMarketingTabs: FunctionComponent<EmailMarketingTabsProps> = ({ selectedTabId, onSelect, className }) => {
    return (
        <div className={clsx(styles.tabs, className)}>
            <button
                type="button"
                className={clsx(styles.tab, {
                    [styles.activeTab]: selectedTabId === emailCampaignsTabId
                })}
                onClick={() => onSelect(emailCampaignsTabId)}
            >
                <FontAwesomeIcon
                    icon={faMegaphone}
                    className={styles.icon}
                />
                <label className={styles.title}>Email Campaigns</label>
            </button>
            <button
                type="button"
                className={clsx(styles.tab, {
                    [styles.activeTab]: selectedTabId === emailTemplatesTabId
                })}
                onClick={() => onSelect(emailTemplatesTabId)}
            >
                <FontAwesomeIcon
                    icon={faEnvelope}
                    className={styles.icon}
                />
                <label className={styles.title}>Email Templates</label>
            </button>
            <button
                type="button"
                className={clsx(styles.tab, {
                    [styles.activeTab]: selectedTabId === emailSenderTabId
                })}
                onClick={() => onSelect(emailSenderTabId)}
            >
                <FontAwesomeIcon
                    icon={faEnvelopeCircleCheck}
                    className={styles.icon}
                />
                <label className={styles.title}>Email Sender</label>
            </button>
        </div>
    );
};

export default EmailMarketingTabs;
